import React from 'react';

function FallbackSentry({ error, componentStack, resetError }) {
  console.log('Error caught by Sentry:', error);
  return (
    <div>
      <h2>Something went wrong</h2>
      <details>
        <summary>Error details</summary>
        <pre>{error.toString()}</pre>
        <pre>{componentStack}</pre>
      </details>
      <button onClick={resetError}>Try again</button>
    </div>
  );
}

export default FallbackSentry;
